import { limitNavbarMenuDepth } from "@/lib/helpers/menuDepth.helpers";
import { NavbarMenuItem, NavbarMenuItemType } from "@/lib/main";
import { CSSProperties, useMemo } from "react";

type Props = { isHashLinks?: boolean; navbarMenuItems: NavbarMenuItemType[] };

export default function NavbarMenu({ isHashLinks, navbarMenuItems }: Props) {
  const safeNavbarMenuItems = useMemo(
    () => limitNavbarMenuDepth(navbarMenuItems, 3),
    [navbarMenuItems],
  );

  const ulStyle: CSSProperties = {
    position: "relative",
    zIndex: "var(--z-index-header-navbar-menu)",

    display: "flex",
    alignItems: "center",

    height: "var(--navbar-height)",

    listStyle: "none",
  };

  return (
    <ul style={ulStyle}>
      {safeNavbarMenuItems.map((item, index) => (
        <NavbarMenuItem
          key={item.id}
          direction="down"
          isLastItem={index === safeNavbarMenuItems.length - 1}
          isHashLinks={isHashLinks}
          navbarMenuItem={item}
        />
      ))}
    </ul>
  );
}
